import $ from 'jquery';
import React from 'react';
import { renderCheckboxList, renderList } from 'utils/async-list';
import { Column } from 'react-virtualized';
import { withReferer } from 'plugins/contextual-back';
import renderLines from './lines';
import renderPayments from './payments';
import renderComments from './comments';
import renderImports from 'modules/saas/invoices/imports';
import { renderCaseCustomer, renderAmount } from 'modules/saas/common/columns';
import { renderLate, renderReminder } from './workflow/toPay';
import { displayConfirmModalIfNeeded } from './emit/confirm-emission';
import { error } from 'plugins/toastr';
import fetch from 'utils/fetch';
import { bindListPdfButtons, ListPDFButton } from 'plugins/pdf-button';
import { bindModal } from '../aast/common/modals';

export function comments() {
  renderComments();
}

export function payments() {
  renderPayments();
}

export function detail() {
  renderImports();
  renderLines();
}

export function assets(ctx) {
  const id = ctx.params.id;
  const referer = `/pco-manager/invoices/${id}/assets`;

  const rowClickedUrl = assetId =>
    withReferer(`/pco-manager/invoices/${assetId}`, referer);

  const loadNextUrl = `/pco-manager/invoices/${id}/assets.json`;

  renderList(rowClickedUrl, loadNextUrl, renderAssetsColumns);
}

export function byEntity() {
  const referer = '/pco-manager/invoices';

  const rowClickedUrl = id =>
    withReferer(`/pco-manager/invoices/${id}`, referer);
  const loadNextUrl = '/pco-manager/invoices.json';

  renderCheckboxList(rowClickedUrl, loadNextUrl, renderEntityColumns);
}

export function byEntityToPrepare(ctx) {
  const referer = ctx.path;

  const rowClickedUrl = id =>
    withReferer(`/pco-manager/invoices/${id}`, referer);
  const loadNextUrl = $('#root').data('action');

  renderList(rowClickedUrl, loadNextUrl, renderEntityToPrepareColumns);
}

function getFetchAction($button, jsonBody) {
  const url = $button.attr('data-action');
  const method = $button.attr('data-method') || 'POST';

  if (url && url.length) {
    return () =>
      fetch(url, {
        headers: {
          'Content-Type': 'application/json',
        },
        method,
        body: jsonBody,
      }).then(res => {
        $button.removeClass('loading');
        window.location.replace(res.url);
      });
  }

  return null;
}

export function byEntityToIssue(ctx) {
  const referer = ctx.path;

  const rowClickedUrl = id =>
    withReferer(`/pco-manager/invoices/${id}`, referer);
  const loadNextUrl = $('#root').data('action');

  renderCheckboxList(rowClickedUrl, loadNextUrl, renderEntityToIssueColumns);

  $('.actionBar .button.selection.emission').on('click', function(evt) {
    evt.preventDefault();
    const selectedIds = $('.actionBar')
      .find('#selected-ids')
      .attr('data-value');
    if (selectedIds && selectedIds.length) {
      // Serialize ids as JSON and execute given URL
      const idsArray = selectedIds.split(',').map(Number);
      const jsonBody = JSON.stringify(idsArray);
      const $button = $(evt.currentTarget);
      const fetchAction = getFetchAction($button, jsonBody);
      displayConfirmModalIfNeeded(idsArray, () => {
        $button.addClass('loading');
        fetchAction().catch(err => {
          console.log('Error attempting to execute selection action', err);

          $button.removeClass('loading');
          error('Une erreur est survenue. Merci de réessayer ultérieurement');
        });
      });
    }
  });
}

export function byEntityWaiting(ctx) {
  const referer = ctx.path;

  const rowClickedUrl = id =>
    withReferer(`/pco-manager/invoices/${id}`, referer);
  const loadNextUrl = $('#root').data('action');

  renderList(rowClickedUrl, loadNextUrl, renderEntityWaitingColumns);
}

export function byEntityLate(ctx) {
  const referer = ctx.path;

  const rowClickedUrl = id =>
    withReferer(`/pco-manager/invoices/${id}`, referer);
  const loadNextUrl = $('#root').data('action');

  renderList(rowClickedUrl, loadNextUrl, renderEntityLateColumns);
}

export function byCase(ctx) {
  const referer = ctx.pathname;

  const rowClickedUrl = id =>
    withReferer(`/pco-manager/invoices/${id}`, referer);
  const loadNextUrl = `${referer}.json`;

  renderCheckboxList(rowClickedUrl, loadNextUrl, renderCaseColumns);
  bindListPdfButtons();
}

export function byAASTCase(ctx) {
  const referer = ctx.pathname;

  const rowClickedUrl = id =>
    withReferer(`/pco-manager/invoices/${id}`, referer);
  const loadNextUrl = `${referer}.json`;

  bindModal();
  renderCheckboxList(rowClickedUrl, loadNextUrl, renderCaseColumns);
  bindListPdfButtons();
}

export function byCustomer(ctx) {
  const id = ctx.params.id;
  const referer = `/pco-manager/customers/${id}/invoices`;

  const rowClickedUrl = id =>
    withReferer(`/pco-manager/invoices/${id}`, referer);
  const loadNextUrl = `/pco-manager/customers/${id}/invoices.json`;

  renderCheckboxList(rowClickedUrl, loadNextUrl, renderCustomerColumns);
  bindListPdfButtons();
}

export const renderStatus = ({ cellData }) => {
  let label, title;

  switch (cellData) {
    case 'TO_PREPARE':
      label = 'ui yellow labels';
      title = 'A préparer';
      break;
    case 'ISSUABLE':
      label = 'ui yellow labels';
      title = 'Emissible';
      break;
    case 'TO_ISSUE':
      label = 'ui yellow labels';
      title = 'A émettre';
      break;
    case 'ISSUED':
      label = 'ui labels';
      title = 'En attente de réglement';
      break;
    case 'PAYED':
      label = 'ui green labels';
      title = 'Réglé';
      break;
    case 'LATE':
      label = 'ui orange labels';
      title = 'Retard';
      break;
    case 'VERY_LATE':
      label = 'ui red labels';
      title = 'Retard';
      break;
    default:
      break;
  }

  if (label && title) {
    return (
      <div className={label}>
        <span className="ui label">{title}</span>
      </div>
    );
  }

  return null;
};

function renderAction({ rowData, key, style }) {
  const id = rowData.id;

  const onClicked = evt => {
    evt.stopPropagation();
  };

  const renderButton = () => {
    if (rowData.file_id) {
      return (
        <ListPDFButton
          key={key}
          style={style}
          href={`/pco-manager/invoices/${id}/pdf`}
          onClick={onClicked}
        />
      );
    }

    return (
      <div key={key} style={style}>
        <label
          className="ui loading pdf label"
          data-url={`/pco-manager/invoices/${id}/pdf`}
        >
          Traitement...
          <div className="ui mini active inline loader" />
        </label>
      </div>
    );
  };

  switch (rowData.status) {
    case 'ISSUED':
    case 'PAYED':
    case 'LATE':
    case 'VERY_LATE':
      if (rowData.number) {
        return renderButton();
      } else {
        return null;
      }
    default:
      return null;
  }
}

function renderEntityColumns(width) {
  return [
    <Column
      key="file_id"
      dataKey="file_id"
      width={(width / 16) * 2}
      cellRenderer={renderAction}
      disableSort
      label="Action"
    />,
    <Column
      key="customer"
      dataKey="customer"
      width={(width / 16) * 4}
      cellRenderer={renderCaseCustomer}
      label="Chantier"
    />,
    <Column
      key="number"
      dataKey="number"
      width={(width / 16) * 2}
      label="N° de facture"
    />,
    <Column
      key="issue_date"
      dataKey="issue_date"
      width={(width / 16) * 2}
      label="Date d'émission"
    />,
    <Column
      key="payment_date"
      dataKey="payment_date"
      width={(width / 16) * 2}
      label="Date de règlement"
    />,
    <Column
      key="status"
      dataKey="status"
      width={(width / 16) * 2.5}
      cellRenderer={renderStatus}
      label="Statut"
    />,
    <Column
      key="amount"
      dataKey="amount"
      headerClassName="right aligned"
      className="right aligned"
      width={(width / 16) * 1.5}
      cellRenderer={renderAmount}
      label="Montant"
    />,
  ];
}

function renderAssetsColumns(width) {
  return [
    <Column
      key="file_id"
      dataKey="file_id"
      width={(width / 16) * 2}
      cellRenderer={renderAction}
      label="Action"
    />,
    <Column
      key="number"
      dataKey="number"
      width={(width / 16) * 2}
      label="N° de facture"
    />,
    <Column
      key="issue_date"
      dataKey="issue_date"
      width={(width / 16) * 3}
      label="Date d'émission"
    />,
    <Column
      key="payment_date"
      dataKey="payment_date"
      width={(width / 16) * 3}
      label="Date de règlement"
    />,
    <Column
      key="status"
      dataKey="status"
      width={(width / 16) * 3}
      cellRenderer={renderStatus}
      label="Statut"
    />,
    <Column
      key="amount"
      dataKey="amount"
      headerClassName="right aligned"
      className="right aligned"
      width={(width / 16) * 3}
      cellRenderer={renderAmount}
      label="Montant"
    />,
  ];
}

function renderCaseColumns(width) {
  return [
    <Column
      key="file_id"
      dataKey="file_id"
      width={(width / 16) * 2}
      cellRenderer={renderAction}
      label="Action"
    />,
    <Column
      key="number"
      dataKey="number"
      width={(width / 16) * 2}
      label="N° de facture"
    />,
    <Column
      key="issue_date"
      dataKey="issue_date"
      width={(width / 16) * 3}
      label="Date d'émission"
    />,
    <Column
      key="payment_date"
      dataKey="payment_date"
      width={(width / 16) * 3}
      label="Date de règlement"
    />,
    <Column
      key="status"
      dataKey="status"
      width={(width / 16) * 3}
      cellRenderer={renderStatus}
      label="Statut"
    />,
    <Column
      key="amount"
      dataKey="amount"
      headerClassName="right aligned"
      className="right aligned"
      width={(width / 16) * 3}
      cellRenderer={renderAmount}
      label="Montant"
    />,
  ];
}

function renderCustomerColumns(width) {
  return [
    <Column
      key="file_id"
      dataKey="file_id"
      width={(width / 16) * 1.5}
      cellRenderer={renderAction}
      label="Action"
    />,
    <Column
      key="case_name"
      dataKey="case_name"
      width={(width / 16) * 3.5}
      label="Chantier"
    />,
    <Column
      key="number"
      dataKey="number"
      width={(width / 16) * 2}
      label="N° de facture"
    />,
    <Column
      key="issue_date"
      dataKey="issue_date"
      width={(width / 16) * 2}
      label="Date d'émission"
    />,
    <Column
      key="payment_date"
      dataKey="payment_date"
      width={(width / 16) * 2}
      label="Date de règlement"
    />,
    <Column
      key="status"
      dataKey="status"
      width={(width / 16) * 2.5}
      cellRenderer={renderStatus}
      label="Statut"
    />,
    <Column
      key="amount"
      dataKey="amount"
      headerClassName="right aligned"
      className="right aligned"
      width={(width / 16) * 2.5}
      cellRenderer={renderAmount}
      label="Montant"
    />,
  ];
}

function renderEntityToPrepareColumns(width) {
  return [
    <Column
      key="customer"
      dataKey="customer"
      width={(width / 16) * 9}
      cellRenderer={renderCaseCustomer}
      label="Chantier"
    />,
    <Column
      key="issue_date"
      dataKey="issue_date"
      width={(width / 16) * 7}
      label="Date d'émission prévue"
    />,
  ];
}

function renderEntityToIssueColumns(width) {
  return [
    <Column
      key="customer"
      dataKey="customer"
      width={(width / 16) * 6}
      cellRenderer={renderCaseCustomer}
      label="Chantier"
    />,
    <Column
      key="issue_date"
      dataKey="issue_date"
      width={(width / 16) * 4}
      label="Date d'émission prévue"
    />,
    <Column
      key="payment_date"
      dataKey="payment_date"
      width={(width / 16) * 4}
      label="Date de réglement"
    />,
    <Column
      key="amount"
      dataKey="amount"
      headerClassName="right aligned"
      className="right aligned"
      width={(width / 16) * 2}
      cellRenderer={renderAmount}
      label="Montant"
    />,
  ];
}

function renderEntityWaitingColumns(width) {
  return [
    <Column
      key="customer"
      dataKey="customer"
      width={(width / 16) * 5}
      cellRenderer={renderCaseCustomer}
      label="Chantier"
    />,
    <Column
      key="number"
      dataKey="number"
      width={(width / 16) * 3}
      label="N° de facture"
    />,
    <Column
      key="issue_date"
      dataKey="issue_date"
      width={(width / 16) * 3}
      label="Date d'émission"
    />,
    <Column
      key="payment_date"
      dataKey="payment_date"
      width={(width / 16) * 3}
      label="Date de règlement"
    />,
    <Column
      key="amount"
      dataKey="amount"
      headerClassName="right aligned"
      className="right aligned"
      width={(width / 16) * 2}
      cellRenderer={renderAmount}
      label="Montant"
    />,
  ];
}

function renderEntityLateColumns(width) {
  return [
    <Column
      key="customer"
      dataKey="customer"
      width={(width / 16) * 5}
      cellRenderer={renderCaseCustomer}
      label="Chantier"
    />,
    <Column
      key="number"
      dataKey="number"
      width={(width / 16) * 2}
      label="N° de facture"
    />,
    <Column
      key="issue_date"
      dataKey="issue_date"
      width={(width / 16) * 2}
      label="Date d'émission"
    />,
    <Column
      key="payment_date"
      dataKey="payment_date"
      width={(width / 16) * 2}
      label="Date de règlement"
    />,
    <Column
      key="amount"
      dataKey="amount"
      headerClassName="right aligned"
      className="right aligned"
      width={(width / 16) * 1.5}
      cellRenderer={renderAmount}
      label="Montant"
    />,
    <Column
      key="payment_date"
      dataKey="payment_date"
      width={(width / 16) * 1}
      cellRenderer={renderLate}
      label="Retard"
    />,
    <Column
      key="reminder"
      dataKey="reminder"
      width={(width / 16) * 2.5}
      cellRenderer={renderReminder}
      label="Relance"
    />,
  ];
}



// WEBPACK FOOTER //
// ./src/modules/saas/invoices/index.js